import { render, staticRenderFns } from "./PanelCheckeds.vue?vue&type=template&id=1a52cb56&"
import script from "./PanelCheckeds.vue?vue&type=script&lang=ts&"
export * from "./PanelCheckeds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports